document.addEventListener("alpine:init", () => {
  Alpine.store("ProductStore", {
    variant: null,
    selectedSellingPlan: {},
    selectedSellingPlanId: null,
    typePurchase: "subscribe",

    /**
     * Set the selected product variant
     * @param {Object} variant - The product variant object
     */
    set(variant) {
      this.variant = variant;
    },

    /**
     * Set the selected selling plan ID
     * @param {String} - The product selling plan ID
     */
    setSellingPlanForVariant(sellingPlanId) {
      this.selectedSellingPlanId = sellingPlanId;
      this.selectedSellingPlan = this.variant.selling_plan_allocations.find(
        (allocation) => allocation.selling_plan_id === sellingPlanId
      );
    },
    /**
     * Change type purchase
     */
    changeTypePurchase(type) {
      this.typePurchase = type;
      console.log("this.typePurchase.Store", this.typePurchase);
    },

    /**
     * Clear the selected variant
     */
    clear() {
      this.variant = null;
    },

    /**
     * Check if a variant is currently selected
     * @returns {Boolean}
     */
    isSelected() {
      return !!this.variant;
    },

    /**
     * Get the formatted price from cents (e.g. $12.99)
     * @returns {String}
     */
    formattedPrice() {
      if (!this.variant || typeof this.variant.price !== "number") return "";
      return `$${(this.variant.price / 100).toFixed(2)}`;
    },
  });
});
